import { Text, Group } from "@mantine/core"
import { Upload, Photo, X } from "tabler-icons-react"

const getIconColor = (status, theme) => {
  return status.accepted
    ? theme.colors[theme.primaryColor][theme.colorScheme === "dark" ? 4 : 6]
    : status.rejected
    ? theme.colors.red[theme.colorScheme === "dark" ? 4 : 6]
    : theme.colorScheme === "dark"
    ? theme.colors.dark[0]
    : theme.colors.gray[7]
}

const ImageUploadIcon = ({ status, ...props }) => {
  if (status.accepted) {
    return <Upload {...props} />
  }

  if (status.rejected) {
    return <X {...props} />
  }

  return <Photo {...props} />
}

export const dropzoneChildren = (status, theme, file) => (
  <Group position='center' spacing='xl' style={{ minHeight: 220, pointerEvents: "none" }}>
    <ImageUploadIcon status={status} style={{ color: getIconColor(status, theme) }} size={60} />
    <div>
      <Text size='lg' inline>
        {file.value
          ? file.value.path
            ? file.value.path
            : file.value
          : "Arrastra una imagen aquí o haz click para seleccionar una."}
      </Text>
      <Text size='sm' color='dimmed' inline mt={7}>
        El tamaño del archivo no debe exceder los 5 MB.
      </Text>
    </div>
  </Group>
)
